"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _api = require("../../api/api");
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
var _default = exports.default = {
  name: 'changeWord-login',
  inject: ['reload'],
  data: function data() {
    return {
      yamImg: '',
      //验证码图片
      showPopup: false,
      //控制弹窗显示隐藏
      codeBtnShow: true,
      //控制验证码按钮
      count: '',
      //验证码按钮倒计时
      timer: null,
      //定时器timer
      regForm: {
        validatePhone: '',
        validateCode: '',
        newPassword: '',
        ticket: '',
        captcha: ''
      },
      regRules: {
        validatePhone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        validateCode: [{
          required: true,
          message: '请输入短信验证码',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }],
        captcha: [{
          required: true,
          message: '请输入图片验证码',
          trigger: 'blur'
        }]
      },
      submitDisabled: false
    };
  },
  methods: {
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？').then(function (_) {
        done();
      }).catch(function (_) {});
    },
    //生成随机字符串
    randAll: function randAll(m) {
      var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var result = '';
      for (var i = 0; i < m; i++) {
        var randomIndex = Math.floor(Math.random() * chars.length);
        result += chars[randomIndex];
      }
      return result;
    },
    //获取验证码图片
    getCaptcha: function () {
      var _getCaptcha = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var param, _yield$apiCaptcha, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              param = {
                ticket: this.randAll(32)
              };
              _context.next = 3;
              return (0, _api.apiCaptcha)(param);
            case 3:
              _yield$apiCaptcha = _context.sent;
              data = _yield$apiCaptcha.data;
              if (data.proCode == 200) {
                this.showPopup = true;
                this.regForm.captcha = '';
                this.yamImg = data.proData.image;
                this.regForm.ticket = data.proData.ticket;
              } else {
                this.showPopup = true;
                this.$message({
                  message: '获取验证码图片失败，请稍后再试!',
                  type: 'error'
                });
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCaptcha() {
        return _getCaptcha.apply(this, arguments);
      }
      return getCaptcha;
    }(),
    // 发送验证码
    toGetCode: function toGetCode() {
      if (!this.regForm.validatePhone) {
        this.$message({
          message: '请先输入手机号',
          type: 'error'
        });
        return;
      }
      return this.getCaptcha();
    },
    getCode: function () {
      var _getCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(param) {
        var that, TIME_COUNT, _yield$apiGetCode, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              TIME_COUNT = 60;
              _context2.next = 4;
              return (0, _api.apiGetCode)(param);
            case 4:
              _yield$apiGetCode = _context2.sent;
              data = _yield$apiGetCode.data;
              if (data.proCode == '200') {
                this.showPopup = false;
                that.$message({
                  message: '发送成功!',
                  type: 'success'
                });
                if (!that.timer) {
                  that.count = TIME_COUNT;
                  that.codeBtnShow = false;
                  that.timer = setInterval(function () {
                    if (that.count > 0 && that.count <= TIME_COUNT) {
                      that.count--;
                    } else {
                      that.codeBtnShow = true;
                      clearInterval(that.timer);
                      that.timer = null;
                    }
                  }, 1000);
                }
              } else {
                this.getCaptcha();
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getCode(_x) {
        return _getCode.apply(this, arguments);
      }
      return getCode;
    }(),
    changeShowPopup: function changeShowPopup() {
      var that = this;
      var param = {
        phone: that.regForm.validatePhone,
        ticket: that.regForm.ticket,
        captcha: that.regForm.captcha,
        type: 1,
        //0登录注册 1忘记密码 2修改交易密码 3退款码 4账户变更码 5绑定银行卡
        sourceType: 10
      };
      that.getCode(param);
    },
    // 修改密码
    toChangePassword: function toChangePassword(formName) {
      var _this = this;
      this.$refs[formName].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          var that, key, password, hmac, encodePassword, jsonParam, _yield$apiGetForgetPa, data;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!valid) {
                  _context3.next = 14;
                  break;
                }
                that = _this;
                key = 'xiamenjinye';
                password = that.regForm.newPassword; // 计算 HMAC-SHA256 并转为 Base64 字符串
                hmac = _cryptoJs.default.HmacSHA256(password, key);
                encodePassword = _cryptoJs.default.enc.Base64.stringify(hmac);
                console.log('加密后的密码:', encodePassword);
                jsonParam = {
                  jsonParamete: JSON.stringify({
                    fun: "forgetPassword",
                    param: {
                      "phone": that.regForm.validatePhone,
                      "verificationCode": that.regForm.validateCode,
                      "userPassword": encodePassword
                    },
                    version: '1'
                  })
                };
                console.log('修改密码参数', jsonParam);
                _context3.next = 11;
                return (0, _api.apiGetForgetPassword)(jsonParam);
              case 11:
                _yield$apiGetForgetPa = _context3.sent;
                data = _yield$apiGetForgetPa.data;
                if (data.proCode == '200') {
                  that.$message({
                    message: '密码修改成功，请重新登录!',
                    type: 'success'
                  });
                  that.$emit('backToLogin');
                } else {
                  that.$message({
                    message: '密码修改失败，请重新尝试!',
                    type: 'warning'
                  });
                }
              case 14:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};